var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRenyuan10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tongyong_renyuan10_svg__clip0_5179_55154)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tongyong_renyuan10_svg__clip1_5179_55154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.953 10.453l3.094 3.094m-3.094 0l3.094-3.094",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.5a.5.5 0 00-.5-.5h-2A3.5 3.5 0 002 12.5v.5a1.5 1.5 0 001.5 1.5h4a.5.5 0 000-1h-4A.5.5 0 013 13v-.5A2.5 2.5 0 015.5 10h2a.5.5 0 00.5-.5z",
    fill: "#3F465C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 2.5,
    stroke: "#3F465C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tongyong_renyuan10_svg__clip0_5179_55154"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tongyong_renyuan10_svg__clip1_5179_55154"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(45 -2.76 17.407)",
    d: "M0 0h7v7H0z"
  })))));
}
export default __webpack_public_path__ + "static/tongyong_renyuan10.7ca87f3c.svg";
export { SvgTongyongRenyuan10 as ReactComponent };